import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-survey-lis-update',
  templateUrl: './admin-survey-lis-update.component.html',
  styleUrls: ['./admin-survey-lis-update.component.css']
})
export class AdminSurveyLisUpdateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
